import LinearProgress from '@mui/material/LinearProgress';
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import {useForm} from "react-hook-form";
import AdditionalHoursForm from "../../../Components/Forms/Pages/HR/AdditionalHours/AdditionalHoursForm";
import strings from "../../../localization";
import { addAdditionalHours } from "../../../Services/HR/AdditionalHoursService";
import { getOrganisationUserContractList } from "../../../Services/HR/OrganisationUserContractService";
import DrawerContext from "../../../Context/DrawerContext";
import SnackbarContext from "../../../Context/SnackbarContext";
import AdditionalHoursStatus from '../../../Constants/HR/AdditionalHoursStatus';

const formRules = {
    'status': {required: true},
    'hours': {required: true},
    'startDate': {required: true},
    'endDate': {required: true},
    'organisationUserContract': {required: true}
}

const AddAdditionalHours = (props) => {
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: {
            startDate: null,
            endDate: null,
            status: AdditionalHoursStatus.PENDING
        }
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [organisationUserContracts, setOrganisationUserContracts] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.additionalHours.addAdditionalHours.pageTitle);
    });

    useEffect(() => {
        fetch();
    }, [])

    const fetch = () => {
        getOrganisationUserContractList().then(response => {
            if (!response || !response.ok){
                return;
            }
            setOrganisationUserContracts(response.data.result);
        })
    }

    const onSubmit = (data) => {
        setShowLoader(true);

        addAdditionalHours(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress />
            }
            <AdditionalHoursForm
                formRules={formRules}
                values={getValues()} setValue={setValue} onChangeUserContractFilter={fetch}
                data={data} errors={errors} form={form} control={control}
                organisationUserContracts={organisationUserContracts}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
            />
        </Paper>
    </div>
}

export default AddAdditionalHours;